/**
 * Runs async tasks one at a time, in the order they are submitted, even when they are submitted
 * while an earlier one is still pending. A task that rejects does not stop the ones behind it, and
 * its rejection is still returned to whoever submitted it.
 *
 * Template placement needs this: each drop reads the spread's top fractional index and its next
 * free uid before it asks the backend for the template, and only moves them forward once the
 * response is in. Two drops in flight together would read the same values and place elements with
 * the same uids and indexes.
 */
export function createSerialRunner(): <T>(task: () => Promise<T>) => Promise<T> {
  let tail: Promise<unknown> = Promise.resolve()

  return (task) => {
    const run = tail.then(task)

    tail = run.catch(() => undefined)

    return run
  }
}
